import script from "./other-content.vue?vue&type=script&setup=true&lang=js"
export * from "./other-content.vue?vue&type=script&setup=true&lang=js"

import "./other-content.vue?vue&type=style&index=0&id=d65fe21a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d65fe21a"]])

export default __exports__